import { Company } from "../models/company";
import { CompanyBuildingUnitView } from "../models/company-building-unit-view";
import { CompanyContact } from "../models/company-contact";


export class CompanyExport {

  public Name: string;
  public Application_Number: string;
  public Company_Type: string;
  public Company_Status: string;
  public Country: string;
  public FTE_PermittedCount: number;
  public FTE_CurrentCount: number;
  public Lease_Issuance_Date: string;
  public Lease_Expiry_Date: string;
  public Company_Profile: string;
  public Company_Mission: string;
  public Company_Address: string;
  public Company_Url: string;

  public Contact_Number: string;
  public Contact_Type: string;

  public License_Name: string;
  public License_Number: string;
  public License_Issuance_Date: string;
  public License_Expiry_Date: string;

  public QSTP_Building: string;
  public Level: string;
  public Unit: string;
  public Unit_Type: string;

 

  constructor(source: Company, companyBuildingSource?: CompanyBuildingUnitView) {
    
      this.Application_Number = source.applicationNumber;
      this.Company_Address = source.companyAddress;
      this.Company_Mission = source.companyMission;
      this.Company_Profile = source.companyProfile;
      this.Company_Status = source.companyStatusName;
      this.Company_Type = source.companyTypeName;
      this.Company_Url = source.companyWebsiteUrl;
      this.Country = source.countryOfOriginName;
      this.FTE_CurrentCount = source.fteCurrentCount;
      this.FTE_PermittedCount = source.ftePermittedCount;
      this.Lease_Expiry_Date = source.leaseExpiryDate;
      this.Lease_Issuance_Date = source.leaseIssuanceDate;
      this.Name = source.name;

      //License
      if (source.companyLicense) {
        this.License_Name = source.companyLicense.name;
        this.License_Number = source.companyLicense.number;
        this.License_Issuance_Date = source.companyLicense.issuanceDate.toString();
        this.License_Expiry_Date = source.companyLicense.expiryDate.toString();
      }

      if(companyBuildingSource)
      {
        this.QSTP_Building = companyBuildingSource.buildingName;
        this.Level = companyBuildingSource.levelName;
        this.Unit = companyBuildingSource.name;
        this.Unit_Type = companyBuildingSource.unitTypeName;
      }

      if (source.companyContacts) {
        var primaryContact: CompanyContact = source.companyContacts.filter(c => c.isPrimary)[0];
        this.Contact_Number = primaryContact && primaryContact.contact && primaryContact.contact.number;
        this.Contact_Type = this.Contact_Number && primaryContact.contact.contactType.name;
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/company-export.ts